/**
 * Created by vladislav on 18.03.2021
 */

const CoinSlotMachineReelView = cc.ClippingNode.extend({
    ctor: function (reel) {
        this._super();

        this.reel = reel;

        this.setClippingEnabled(true);

        const styles = cleverapps.styles.CoinSlotMachineReelView;

        this.setContentSize2(styles);

        this.reel.symbols.forEach((symbol) => {
            this.addChild(new CoinSlotMachineSymbolView(symbol));
        });
    },

    getCurrentSymbolView: function () {
        return this.children.find((symbolView) => symbolView.symbol && symbolView.symbol === this.reel.getCurrent());
    }
});

cleverapps.styles.CoinSlotMachineReelView = {
    width: 140,
    height: 426
};